function linkedHeader(t, i18nKey, value, overrides = {}) {
  return {
    text: t(i18nKey),
    value,
    sortable: false,
    ...overrides,
  };
}

/**
 * Shared column order for linked document tables:
 * code → status → counterparty → warehouse → date → lines → total → extra columns
 */
export function buildLinkedDocumentHeaders(t, options = {}) {
  const {
    codeLabelKey = "STOCK.RECEIPTS.DOCUMENT_CODE",
    counterpartyLabelKey = null,
    counterpartyValue = "counterparty",
    warehouseLabelKey = "STOCK.RECEIPTS.WAREHOUSE",
    warehouseValue = "warehouse",
    dateLabelKey = "STOCK.RECEIPTS.DATE",
    dateValue = "action_date",
    linesLabelKey = "STOCK.RECEIPTS.LINES",
    linesValue = "items_count",
    totalLabelKey = "STOCK.SALES_ORDERS.TOTAL_GROSS",
    totalValue = "total_gross",
    includeCounterparty = true,
    includeWarehouse = true,
    includeDate = true,
    includeLines = true,
    includeTotal = true,
  } = options;

  const headers = [
    linkedHeader(t, codeLabelKey, "code"),
    linkedHeader(t, "GENERAL.LABELS.STATUS", "status"),
  ];

  if (includeCounterparty && counterpartyLabelKey) {
    headers.push(linkedHeader(t, counterpartyLabelKey, counterpartyValue));
  }

  if (includeWarehouse) {
    headers.push(linkedHeader(t, warehouseLabelKey, warehouseValue));
  }

  if (includeDate) {
    headers.push(linkedHeader(t, dateLabelKey, dateValue));
  }

  if (includeLines) {
    headers.push(linkedHeader(t, linesLabelKey, linesValue));
  }

  if (includeTotal) {
    headers.push(linkedHeader(t, totalLabelKey, totalValue));
  }

  return headers;
}

export function linkedReceiptFinancialHeaders(t) {
  return [
    linkedHeader(t, "STOCK.MOVEMENTS.INVENTORY_COST", "total_inventory_cost_net"),
  ];
}

export function linkedSaleFinancialHeaders(t) {
  return [
    linkedHeader(t, "STOCK.MOVEMENTS.TOTAL_COGS", "total_cost_of_goods_net"),
    linkedHeader(t, "STOCK.MOVEMENTS.TOTAL_MARGIN", "total_margin_net"),
    linkedHeader(t, "STOCK.MOVEMENTS.MARGIN_PCT", "margin_pct"),
  ];
}

export function linkedTransportOrderReferenceHeader(t) {
  return linkedHeader(t, "STOCK.TRANSPORT_ORDERS.DOCUMENT_CODE", "transport_order_code");
}
